import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-compare',
  templateUrl: './pricing-compare.component.html',
  styleUrls: ['./pricing-compare.component.scss']
})
export class PricingCompareComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
